import { dialAndCountryCodeArray } from "./constants";

export function formatDate(date) {
  if (!date) return null;
  try {
    if (date instanceof Date) return date.toISOString().slice(0, 10);
    const formatDate = new Date(
      date.seconds * 1000 + date.nanoseconds / 1000000
    );
    return formatDate.toISOString().slice(0, 10);
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function createRandomId(length, onlyCapital = false) {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  if (onlyCapital) characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function addDaysToCurrentDate(daysToAdd) {
  let today = new Date();
  today.setDate(today.getDate() + daysToAdd);
  return today;
}

export const findCodeBasedOnType = (type, value) => {
  let results = dialAndCountryCodeArray.find((obj) => obj[type] == value);

  let error = results ? { error: false, data: results } : { error: true };
  return error;
};

export const isMoreThanOneHour = (timestamp) => {
  const oneHourInMilliseconds = 1 * 60 * 1000; // 1 hour in milliseconds
  const currentTime = Date.now();
  const timeDifference = currentTime - timestamp;

  return timeDifference < oneHourInMilliseconds;
};

export const isLessThanRequiredSeconds = (timestamp) => {
  // Get the current timestamp in milliseconds
  const currentTimestamp = Date.now();
  // Calculate the difference between current timestamp and the given timestamp
  const differenceInSeconds = Math.abs((currentTimestamp - timestamp) / 1000);
  // console.log(
  //   "timestamp < currentTimestamp :: ",
  //   timestamp,
  //   "=== ",
  //   currentTimestamp,
  //   " ",
  //   timestamp < currentTimestamp
  // );
  // Check if the difference is not more than 4 seconds
  if (differenceInSeconds < 2 && timestamp <= currentTimestamp) {
    return true; // Difference is within 4 seconds
  } else {
    return false; // Difference is more than 4 seconds
  }
};

export const handleUserLoginCode = () => {
  let randomCode = createRandomId(10);
  localStorage.setItem(
    "auth_detail",
    JSON.stringify({
      time: Date.now(),
      code: randomCode,
      checked: false,
    })
  );
};

